/* Client-side validation for the Booking / Membership request forms.
   Progressive enhancement: native HTML attributes (required, type, pattern)
   still validate if JS is off. When JS runs we take over with inline messages
   for a cleaner UX, with stricter email / phone checks. */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function digits(v) {
    return (v || '').replace(/\D/g, '');
  }
  function isEmail(v) {
    return EMAIL_RE.test((v || '').trim());
  }
  function isPhone(v) {
    var d = digits(v);
    return d.length >= 10 && d.length <= 15;
  }
  function fieldOf(el) {
    return el.closest('.cb-request-form__field') || el.parentNode;
  }
  function setError(el, msg) {
    var field = fieldOf(el);
    var err = field.querySelector('.cb-request-form__field-error');
    if (!err) {
      err = document.createElement('span');
      err.className = 'cb-request-form__field-error';
      field.appendChild(err);
    }
    err.textContent = msg;
    el.classList.add('cb-request-form__input--error');
    el.setAttribute('aria-invalid', 'true');
  }
  function clearError(el) {
    var field = fieldOf(el);
    var err = field.querySelector('.cb-request-form__field-error');
    if (err) err.textContent = '';
    el.classList.remove('cb-request-form__input--error');
    el.removeAttribute('aria-invalid');
  }
  function validateLocationFieldset(fieldset) {
    var err = fieldset.querySelector('.cb-form-location__error');
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked) {
      if (err) err.textContent = 'Please select a location.';
      fieldset.classList.add('cb-form-location--error');
      return false;
    }
    if (err) err.textContent = '';
    fieldset.classList.remove('cb-form-location--error');
    return true;
  }
  function validateField(el) {
    if (el.type === 'hidden' || el.type === 'checkbox' || el.type === 'radio') return true;
    var val = el.value;
    var type = (el.getAttribute('type') || '').toLowerCase();
    var name = el.getAttribute('name') || '';
    var hasValue = String(val).trim().length > 0;

    if (el.hasAttribute('required') && !hasValue) {
      setError(el, 'Please fill out this field.');
      return false;
    }
    if ((type === 'email' || name.indexOf('[email]') > -1) && hasValue && !isEmail(val)) {
      setError(el, 'Please enter a valid email address.');
      return false;
    }
    if (type === 'tel' && hasValue && !isPhone(val)) {
      setError(el, 'Please enter a valid phone number (include area code).');
      return false;
    }
    clearError(el);
    return true;
  }

  function initForm(form) {
    if (form.dataset.cbValidate) return;
    form.dataset.cbValidate = '1';
    form.noValidate = true;

    var controls = form.querySelectorAll('input, select, textarea');
    controls.forEach(function (el) {
      if (el.type === 'hidden') return;
      el.addEventListener('blur', function () {
        validateField(el);
      });
      el.addEventListener('input', function () {
        if (el.classList.contains('cb-request-form__input--error')) validateField(el);
      });
      el.addEventListener('change', function () {
        var locationFieldset = el.closest('[data-cb-form-location]');
        if (locationFieldset) validateLocationFieldset(locationFieldset);
      });
    });

    form.querySelectorAll('[data-cb-form-location]').forEach(function (fieldset) {
      fieldset.addEventListener('change', function () {
        validateLocationFieldset(fieldset);
      });
    });

    form.addEventListener('submit', function (e) {
      var ok = true;
      var firstInvalid = null;
      form.querySelectorAll('[data-cb-form-location]').forEach(function (fieldset) {
        if (!validateLocationFieldset(fieldset)) {
          ok = false;
          if (!firstInvalid) firstInvalid = fieldset.querySelector('input[type="radio"]');
        }
      });
      controls.forEach(function (el) {
        if (el.type === 'hidden') return;
        if (el.type === 'checkbox') {
          var consent = el.closest('.cb-request-form__consent');
          if (el.hasAttribute('required') && !el.checked) {
            ok = false;
            if (!firstInvalid) firstInvalid = el;
            if (consent) consent.classList.add('cb-request-form__consent--error');
          } else if (consent) {
            consent.classList.remove('cb-request-form__consent--error');
          }
          return;
        }
        if (el.type === 'radio') return;
        if (!validateField(el)) {
          ok = false;
          if (!firstInvalid) firstInvalid = el;
        }
      });
      if (!ok) {
        e.preventDefault();
        if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.cb-request-form__form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
